import React from 'react'

import { useTheme } from 'styled-components/native'

import { InfoIcon } from '../../atoms/icons/InfoIcon'
import { InlineBanner, InlineBannerProps } from '../inlineBanner/InlineBanner'

export interface InlineInfoBannerProps extends Omit<InlineBannerProps, 'backgroundColor'> {
  text: React.ReactNode | string
  testId?: string
  backgroundColor?: string
  iconColor?: string
  textColor?: string
  marginBottom?: string
  marginTop?: string
  iconSize?: number
  /** When provided, replaces the default InfoIcon entirely. `iconColor` and `iconSize` are ignored. */
  icon?: React.ReactElement
}

export const InlineInfoBanner: React.FC<InlineInfoBannerProps> = ({
  text,
  testId,
  backgroundColor,
  iconColor,
  textColor,
  marginBottom,
  marginTop,
  trailingLink,
  iconSize,
  title,
  textSize,
  borderRadius,
  textAlign,
  icon: iconOverride,
  centerContent,
  useInnerContainer,
  padding,
}) => {
  const { colors } = useTheme()
  const { inlineInfoBanner } = colors.components

  const icon = iconOverride ?? (
    <InfoIcon size={iconSize ?? 15} fillColor={iconColor || inlineInfoBanner.infoIcon.fill} />
  )
  return (
    <InlineBanner
      text={text}
      title={title}
      icon={icon}
      testId={testId}
      backgroundColor={backgroundColor || inlineInfoBanner.background}
      textColor={textColor || inlineInfoBanner.text}
      marginBottom={marginBottom}
      marginTop={marginTop}
      trailingLink={trailingLink}
      textSize={textSize}
      borderRadius={borderRadius}
      textAlign={textAlign}
      centerContent={centerContent}
      useInnerContainer={useInnerContainer}
      padding={padding}
    />
  )
}
